/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParameterAllowedValueDto
 */
export interface ParameterAllowedValueDto {
    /**
     * The value.
     * @type {string}
     * @memberof ParameterAllowedValueDto
     */
    value: string;
    /**
     * The display label.
     * @type {string}
     * @memberof ParameterAllowedValueDto
     */
    label: string;
    /**
     * The hints to explain the value.
     * @type {string}
     * @memberof ParameterAllowedValueDto
     */
    hint: string | null;
    /**
     * The display label.
     * @type {Array<string>}
     * @memberof ParameterAllowedValueDto
     */
    updateFrom: Array<string> | null;
}

/**
 * Check if a given object implements the ParameterAllowedValueDto interface.
 */
export function instanceOfParameterAllowedValueDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "hint" in value;
    isInstance = isInstance && "updateFrom" in value;

    return isInstance;
}

export function ParameterAllowedValueDtoFromJSON(json: any): ParameterAllowedValueDto {
    return ParameterAllowedValueDtoFromJSONTyped(json, false);
}

export function ParameterAllowedValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterAllowedValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
        'hint': json['hint'],
        'updateFrom': json['updateFrom'],
    };
}

export function ParameterAllowedValueDtoToJSON(value?: ParameterAllowedValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'label': value.label,
        'hint': value.hint,
        'updateFrom': value.updateFrom,
    };
}

